(function(){document.addEventListener('theme:variant:change',function(event){var variant=event.detail.variant;var container=event.target;if(variant){console.log('Container ———————— ↓');console.log(container);console.log('Variant —————————— ↓');console.log(variant)}});document.addEventListener('theme:cart:change',function(event){var cart=event.detail.cart;if(cart){console.log('Cart ———————————— ↓');console.log(cart)}});document.addEventListener('theme:cart:init',(e)=>{console.log('theme:cart:init');console.log(e)});document.addEventListener('theme:scroll',e=>{console.log(e)});document.addEventListener('theme:scroll:up',e=>{console.log(e)});document.addEventListener('theme:scroll:down',e=>{console.log(e)});document.addEventListener('theme:resize',e=>{console.log(e)})})();

/* Spiritum fix: the theme's built-in mobile submenu (sliderule) component fails to
   initialize reliably on this store, so DECOUVERTE / LA MAISON / CALCULATEURS never
   expanded when tapped in the burger menu. The native component also relies on a
   sliding-pane system (absolute position + horizontal transform) that needs an exact
   pixel height calculated by that same broken component, so simply toggling the
   "is-visible" class left the panel positioned off-screen with 0 height (looked empty).
   This override forces the submenu panel to render as a simple in-place accordion
   (relative position, natural height) instead of relying on the sliding system, and
   drives open/close with plain JS independent of the theme's own broken init. */
;(function () {
  var style = document.createElement('style');
  style.textContent = [
    '.drawer__menu { transform: none !important; }',
    '.sliderule__panel.is-visible {',
    '  position: static !important;',
    '  left: auto !important;',
    '  top: auto !important;',
    '  width: 100% !important;',
    '  height: auto !important;',
    '  max-height: none !important;',
    '  overflow: visible !important;',
    '  transform: none !important;',
    '}',
    '.sliderule__panel.is-visible [data-animates] {',
    '  opacity: 1 !important;',
    '  transform: none !important;',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  document.addEventListener('click', function (e) {
    var quicknav = e.target.closest('[data-quicknav-href]');
    if (quicknav) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = quicknav.getAttribute('data-quicknav-href');
      return;
    }

    var opener = e.target.closest('[data-sliderule-open]');
    if (opener) {
      var panel = document.getElementById(opener.getAttribute('data-sliderule-open'));
      if (panel) {
        e.preventDefault();
        e.stopPropagation();
        var wasOpen = panel.classList.contains('is-visible');
        document.querySelectorAll('.sliderule__panel.is-visible').forEach(function (p) {
          p.classList.remove('is-visible');
        });
        if (!wasOpen) {
          panel.classList.add('is-visible');
        }
      }
      return;
    }

    var closer = e.target.closest('[data-sliderule-close]');
    if (closer) {
      var panel2 = document.getElementById(closer.getAttribute('data-sliderule-close'));
      if (panel2) {
        e.preventDefault();
        e.stopPropagation();
        panel2.classList.remove('is-visible');
      }
    }
  }, true);
})();